/* VERMELI — lightweight wishlist (localStorage, no app, no account needed).
   Stores product handles. Powers heart toggles on cards/PDP, the header count
   badge, and the /pages/wishlist grid (hydrated from {handle}.js). */
(function () {
  var KEY = 'vermeli:wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('vm:wishlist:change', { detail: list }));
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    write(list);
    return list.indexOf(handle) !== -1;
  }

  function paintButton(btn) {
    var on = has(btn.getAttribute('data-wishlist'));
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }
  function paintAll() {
    document.querySelectorAll('[data-wishlist]').forEach(paintButton);
  }
  function paintCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }

  // Delegate clicks on any heart button.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist]');
    if (!btn) return;
    e.preventDefault();
    toggle(btn.getAttribute('data-wishlist'));
    paintButton(btn);
  });

  document.addEventListener('vm:wishlist:change', function () {
    paintAll();
    paintCount();
  });

  // Hydrate the wishlist page grid, if present.
  function renderGrid() {
    var grid = document.getElementById('vm-wishlist-grid');
    if (!grid) return;
    var list = read();
    var empty = document.getElementById('vm-wishlist-empty');
    if (empty) empty.style.display = list.length ? 'none' : '';
    grid.innerHTML = '';
    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var money = (p.price / 100).toLocaleString(undefined, { minimumFractionDigits: 2 });
          var el = document.createElement('div');
          el.className = 'vm-wishlist-card';
          el.innerHTML =
            '<a href="/products/' + handle + '">' +
            (p.featured_image ? '<img src="' + p.featured_image + '&width=400" alt="" loading="lazy">' : '') +
            '<span class="vm-wishlist-card__name">' + p.title + '</span>' +
            '<span class="vm-wishlist-card__price">AED ' + money + '</span></a>' +
            '<button type="button" class="vm-wishlist-card__remove" data-wishlist="' + handle + '">Remove</button>';
          grid.appendChild(el);
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    paintAll();
    paintCount();
    renderGrid();
  });
  document.addEventListener('vm:wishlist:change', renderGrid);
})();
